import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
// @ts-expect-error Untyped import
import FullPageTemplateReportViewer from './FullPageTemplateReportViewer';
// @ts-expect-error Untyped import
import { getListingPageContentAreaHeight } from '../../containers/CustomListingPageWrapper';
import AnalyticsSuitesBreadCrumbs from '../common/AnalyticsSuitesBreadCrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
const AnalyticsReportViewer = ({
  subAppKey
}) => {
  const theme = useTheme();
  const {
    collectionId,
    categoryId
  } = useParams();
  const breadcrumbs = /*#__PURE__*/_jsx(AnalyticsSuitesBreadCrumbs, {
    collectionId: collectionId,
    categoryId: categoryId,
    subAppKey: subAppKey
  });
  return /*#__PURE__*/_jsx(FullPageTemplateReportViewer, {
    subAppKey: subAppKey,
    height: getListingPageContentAreaHeight(theme),
    breadcrumbs: breadcrumbs
  });
};
export default AnalyticsReportViewer;